import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthShell, GoogleButton, AuthField, AuthError } from "../components/AuthShell";
import { formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to your engineering workspace.">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <GoogleButton label="Sign in with Google" />
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest text-zinc-600">
          <div className="h-px flex-1 bg-zinc-800" /> or <div className="h-px flex-1 bg-zinc-800" />
        </div>
        <AuthError message={error} />
        <AuthField label="Work email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="login-email" />
        <AuthField label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-xs text-blue-400 hover:text-blue-300" data-testid="forgot-link">Forgot password?</Link>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-colors">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
      <p className="mt-6 text-sm text-zinc-400 text-center">
        New here?{" "}
        <Link to="/register" className="text-blue-400 hover:text-blue-300 font-medium" data-testid="go-register">Create an account</Link>
      </p>
    </AuthShell>
  );
}
